"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldSkipCatalogueLinkQuery = void 0;
var _tsUtils = require("@ori/ts-utils");
var _net = require("../models/graphql-types/net");
/**
 *  Check if should skip catalogue dynamic link query
 *
 *  @param {ShouldSkipPdpLinkParams} props
 *  @returns {boolean}
 */

const shouldSkipCatalogueLinkQuery = ({
  loadingHeaders,
  type,
  cataloguePageNumber,
  catalogueId
}) => !catalogueId || !(0, _tsUtils.isNonNullable)(cataloguePageNumber) || loadingHeaders || type !== _net.FeedbackBenefitBannerType.ShareAndEarn;
exports.shouldSkipCatalogueLinkQuery = shouldSkipCatalogueLinkQuery;
